<template>
	<div class="table-forms">

		<div class="has-forms" v-if="forms && forms.length > 0">
			<div class="the-table">
				<div class="headers">
					<div class="row">
						<span>Name</span>
						<span>Time points</span>
						<span>Blocks</span>
						<span>Submissions</span>
						<span>Active</span>
						<span>Options</span>
					</div>
				</div>
				<div class="table">
					<div 
						class="row"
						v-for="(form, index) in forms"
						:key="index"
						>
						<span>
							{{ form.name }}
						</span>
						<span>
							{{ timePointOutput(form.timepoint) }}
						</span>
						<span>
							{{ form.upload ? 'Upload' : (form.blocks ? form.blocks.length : 0) }}
						</span>
						<span>
							{{ form.results_count ? form.results_count : 0 }}
						</span>
						<span>
							<div 
								class="active-dot" 
								:class="form.active ? 'active' : 'inactive'"
								/>
						</span>
						<span>
							<i 
								v-if="!form.upload"
								class="fal fa-th-large"
								@click="editBlocks(form.id)"
								/>
							<i 
								class="fal fa-pencil"
								@click="editForm(form.id)"
								/>
							<i 
								class="fal fa-trash-alt"
								v-if="$page.props.user.user_type == 'admin'"
								@click="openDeleteModal(form.id)"
								/>
						</span>
					</div>
				</div>
			</div>

		</div>

		<div class="empty-results" v-else>
			<Placeholder 
				message="No forms found, why not start by creating one!"
				>

				<Button 
					label="Add new form"
					color="green"
					size="regular"
					icon="plus"
					@click="addNewForm"
					/>

			</Placeholder>
		</div>

		<Modal 
			v-if="deleteModalOpen && formIdToDelete"
			title="Delete Form"
			@close="closeDeleteModal"
			>

			<span>
				Are you sure you wish to delete this form? This will make it impossible to retrieve past results attributed to this form. Consider instead deactivating so that you can retrieve past form submissions!
			</span>

			<div class="buttons">
				<Button 
					label="Yes, delete"
					color="red"
					size="regular"
					icon="trash-alt"
					@click="deleteForm"
					/>

				<Button
					label="Cancel"
					color="white"
					size="regular"
					icon="times"
					@click="closeDeleteModal"
					/>
			</div>
		</Modal>

	</div>
</template>

<script>

import Placeholder from "@/Components/Placeholder"
import Button from "@/Components/Button"
import Modal from "@/Components/Modal"

export default {
	components: {
		Placeholder,
		Button,
		Modal
	},
	props: {
		forms: [Array, Object]
	},
	data: () => {
		return {
			deleteModalOpen: false,
			formIdToDelete: null	
		}
	},
	mounted(){

		// console.log('forms', this.forms)
	},
	methods: {
		openDeleteModal(id){
			this.deleteModalOpen = true
			this.formIdToDelete = id
		},
		closeDeleteModal(){
			this.deleteModalOpen = false
			this.formIdToDelete = null
		},
		deleteForm(){

			this.$inertia.post(`/admin/pms-forms/${this.formIdToDelete}/delete`, {},
			{
				onFinish: () => {
					this.closeDeleteModal()
					this.$emit('deletedForm', this.formIdToDelete)
				}
			})
			
		},
		addNewForm(){
			this.$emit('addNewForm')
		},
		editBlocks(id){
			this.$emit('editBlocks', id)
		},
		editForm(id){
			this.$emit('editForm', id)
		},
		timePointOutput(timepoint){

			if(timepoint){
				switch(timepoint.mode){
					case 'once-after-surgery':
						return 'Once, after surgery date'
					case 'once-before-pms':
						return 'Once, before PMS stage'
					case 'user-triggered':
						return 'User Triggered'
					case 'time-intervals':
						let weeks = timepoint.points.map(point => point.weeks).join(', ')
						return 'Weeks: ' + weeks
					default:
						return 'N/A'
				}
			}else{
				return 'N/A'
			}
		}
	},
	computed: {
		
	},
}
</script>

<style lang="sass" scoped>

.table-forms
	width: 100%
	display: flex
	flex-direction: column
	margin-bottom: 30px

	.has-forms
		display: flex
		flex-direction: column
		gap: 20px
		margin-bottom: 20px

	.the-table
		.headers
			font-size: 18px
			font-weight: 700
			font-family: 'Roboto Condensed', sans-serif
			color: #252525
			line-height: 1.1
			margin-bottom: 10px

			.row
				padding: 0 20px

		.row
			display: grid
			grid-template-columns: 1fr 0.5fr 0.3fr 0.3fr 0.3fr 140px

			span
				display: flex
				align-items: center

				&:last-child
					justify-content: flex-end

			.active-dot
				width: 15px
				height: 15px
				border-radius: 50%
				background-color: #d00
				transition: all 300ms

				&.active
					background-color: #0d0

		@media (max-width: 900px)
			overflow-x: auto
			
			.row
				display: flex

				span
					min-width: 190px

		.table
			width: 100%
			background-color: #fff
			border-radius: 8px
			box-shadow: 0 1px 3px rgba(#000, 0.12)
			padding: 0 20px

			.row
				font-size: 16px
				font-weight: 400
				font-family: 'Roboto', sans-serif
				color: #252525
				line-height: 1.1
				height: 60px
				border-bottom: 1px solid #d0d0d0
				align-items: center

				&.deleting
					color: darken(#f00, 10%)

				&:last-child
					border-bottom: none

				.fal
					font-size: 22px
					color: #252525
					margin-left: 20px
					transition: all 300ms
					cursor: pointer

					&:hover
						opacity: 0.7

	.buttons
		margin-top: 20px
		display: flex
		gap: 10px

</style>
